var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { DynamicFormBuilderContainer } from "../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { areaFieldFailureReportsGetAPI } from "../../../../services/apiCalls";
import { FormItemTypes } from "../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { ReactComponent as CloseIcon } from "../../../../../../assets/images/closeIcon.svg";
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../../../../../assets/customIcons";
import { EditIcon } from "../../../../../fieldFailureReports/assets/svg";
import { AreaFieldReportsKeys } from "../../../../services/entity";
import { ChildFF } from "../../../FFRs/components/ChildFFR";
import { HistoryTab } from "../../../FFRs/components/HistoryTab";
import { problemDescriptionOrChangeMobileView } from "./problemDescriptionTAB";
import { basicDetailsAndVehicleDetails } from "../../../../../fieldFailureReports/components/fieldFailureReportCreateForm/BasicDetailsAndVehicleDetails";
import { CourierDetails } from "../../../AFRs/components/ViewComponent/courierDetails";
import { vehicleDefectivePartDetailsMobileView } from "./generalTAB";
import { StateWiseFailuresReported } from "../StateWiseFailuresReported";
import { useAppSelector } from "../../../../../../store/hooks";
var areaFieldReportDetailsMobileView = function (_ref) {
    var _crud$AreaFieldReport, _crud$AreaFieldReport2;
    var onClose = _ref.onClose, data = _ref.data;
    var navigate = useNavigate();
    var crud = useAppSelector(function (state) { return state.crud; });
    console.log(((_crud$AreaFieldReport = crud[AreaFieldReportsKeys.get]) === null || _crud$AreaFieldReport === void 0 || (_crud$AreaFieldReport = _crud$AreaFieldReport.data) === null || _crud$AreaFieldReport === void 0 ? void 0 : _crud$AreaFieldReport.Status) === "Resent by PSG");
    var BasicDetailsAndVehicleDetails = basicDetailsAndVehicleDetails(true);
    var GenralViewSection = __spreadArray(__spreadArray([], BasicDetailsAndVehicleDetails, true), [{
            type: FormItemTypes.ContainerItem,
            name: "",
            columnSize: 12,
            elements: __spreadArray(__spreadArray([{
                    type: FormItemTypes.Custom,
                    name: 'CourierData',
                    columnSize: true,
                    element: CourierDetails
                }], vehicleDefectivePartDetailsMobileView, true), [{
                    type: FormItemTypes.Custom,
                    name: 'StatewiseCount',
                    columnSize: true,
                    element: StateWiseFailuresReported
                }], false)
        }], false);
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "",
            label: "",
            value: "",
            columnSize: 12,
            display: "flex",
            spacing: 0,
            pl: 2,
            item: false,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: 'root',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: "DocumentName",
                            valueGetter: function (state) { return "Details - ".concat(state.AFRDocumentName); },
                            fontWeight: "strong",
                            fontSize: "xl",
                            columnSize: true
                        }, {
                            type: FormItemTypes.IconButton,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                color: "text.secondary",
                                height: "12px",
                                width: "12px"
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose(false);
                            }
                        }]
                }, {
                    type: FormItemTypes.Chip,
                    name: "Status",
                    value: function (state) { return state.Status; },
                    columnSize: 12,
                    color: "info",
                    sx: {
                        borderRadius: 1
                    }
                }]
        }, {
            type: FormItemTypes.Divider,
            name: "",
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: "",
            sx: {
                pt: 0,
                pb: 10
            },
            columnSize: true,
            elements: [{
                    type: FormItemTypes.Tabs,
                    name: "tab",
                    label: "",
                    value: null,
                    tabs: ((_crud$AreaFieldReport2 = crud[AreaFieldReportsKeys.get]) === null || _crud$AreaFieldReport2 === void 0 || (_crud$AreaFieldReport2 = _crud$AreaFieldReport2.data) === null || _crud$AreaFieldReport2 === void 0 ? void 0 : _crud$AreaFieldReport2.Status) === "Resent by PSG" ? [{
                            id: "0",
                            label: "General",
                            elements: GenralViewSection
                        }, {
                            id: "1",
                            label: "Problem description OR Change sequence",
                            elements: problemDescriptionOrChangeMobileView
                        }, {
                            id: "2",
                            label: "History",
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    name: "history",
                                    columnSize: 12,
                                    spacing: 0,
                                    element: HistoryTab
                                }]
                        }, {
                            id: "3",
                            label: "ChildFFR",
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    name: "childFFR",
                                    columnSize: 12,
                                    spacing: 0,
                                    element: ChildFF
                                }]
                        }] : [{
                            id: "0",
                            label: "General",
                            elements: GenralViewSection
                        }, {
                            id: "1",
                            label: "Problem description OR Change sequence",
                            elements: problemDescriptionOrChangeMobileView
                        }, {
                            id: "3",
                            label: "ChildFFR",
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    name: "childFFR",
                                    columnSize: 12,
                                    spacing: 0,
                                    element: ChildFF
                                }]
                        }],
                    valueExpr: "id",
                    displayExpr: "label",
                    columnSize: 12,
                    variant: "scrollable"
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'Footer',
            columnSize: 12,
            justifyContent: 'end',
            sx: {
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                padding: 2,
                backgroundColor: 'background.paper',
                borderTop: '1px solid',
                borderColor: 'divider',
                zIndex: 1
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: true,
                    item: false,
                    justifyContent: "end",
                    spacing: 1,
                    alignItems: "center",
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary"
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary"
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary"
                        }, (data === null || data === void 0 ? void 0 : data.Status) === 'Open' ? {
                            type: FormItemTypes.Button,
                            name: '',
                            columnSize: 0,
                            startIcon: /*#__PURE__*/ React.createElement(EditIcon, null),
                            variant: "outlined",
                            color: 'primary',
                            onClick: function () {
                                if (data !== null && data !== void 0 && data.id) {
                                    navigate("/areaFieldReports/afr/".concat(data === null || data === void 0 ? void 0 : data.id));
                                    onClose();
                                }
                            }
                        } : null]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        p: 2,
        sx: {
            paddingTop: {
                md: "60px",
                lg: "60px"
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        gridProps: {
            spacing: 0,
            gap: "20px"
        },
        formData: formData,
        getFormAPI: areaFieldFailureReportsGetAPI,
        getKey: AreaFieldReportsKeys.get,
        getRequest: {
            id: data === null || data === void 0 ? void 0 : data.id
            // id: '80a58080-94c9-404a-ba0e-f42b70a9a0fc'
        }
    })));
};
export default areaFieldReportDetailsMobileView;
